import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
        is_logged_in:              false,
        api_token:                 null,

        user:                      null,

        api_url:                   process.env.VUE_APP_API_URL,

        client_url:                '',
        socket_url:                '',
        socket_is_connected:       false,

        cookie_status:             false,

        stellar_network:           process.env.VUE_APP_STELLAR_NETWORK,
        stellar_network_url:       process.env.VUE_APP_STELLAR_NETWORK_URL,

        collection_upload_id:      null,
        collection_upload_subject: null,
	},
	
	
	getters: {
        IS_LOGGED_IN(state) {
            return state.is_logged_in;
        },
		
        API_TOKEN(state) {
            return state.api_token;
        },

        API_URL(state) {
            return state.api_url;
        },

        CLIENT_URL(state) {
            return state.client_url;
        },

        SOCKET_URL(state) {
            return state.socket_url;
        },

        SOCKET_IS_CONNECTED(state) {
            return state.socket_is_connected;
        },

        USER(state) {
            return state.user;
        },

        USER_NAME(state) {
			var name = null;
			
			if (state.user  &&  state.user.name) {
				name = state.user.name;
			}
			
            return name;
        },

        COOKIE_LAW(state) {
            return state.cookie_status;
        },

        GET_STELLAR_NETWORK(state) {
            return state.stellar_network;
        },
        GET_STELLAR_NETWORK_URL(state) {
            return state.stellar_network_url;
        },

        COLLECTION_UPLOAD_ID(state) {
            return state.collection_upload_id;
        },
        COLLECTION_UPLOAD_SUBJECT(state) {
            return state.collection_upload_subject;
        },
	},
	

	mutations: {
        IS_LOGGED_IN: (state, payload) => {
            state.is_logged_in = payload;
        },
		
        API_TOKEN: (state, payload) => {
            state.access_token = payload;
        },

        API_URL: (state, payload) => {
            state.api_url = payload;
        },

        CLIENT_URL: (state, payload) => {
            state.client_url = payload;
        },

        SOCKET_URL: (state, payload) => {
            state.socket_url = payload;
        },

        SOCKET_IS_CONNECTED: (state, payload) => {
            state.socket_is_connected = payload;
        },
		
        USER: (state, payload) => {
            state.user = payload;
        },

        RESET: (state) => {
            state.is_logged_in = false;
            state.api_token    = null;
			state.user         = null;
        },

        API_URL(state, payload) {
            state.api_url = payload;
        },

        CLIENT_URL(state, payload) {
            state.client_url = payload;
        },

        SOCKET_URL(state, payload) {
            state.socket_url = payload;
        },

        SOCKET_IS_CONNECTED(state, payload) {
            state.socket_is_connected = payload;
        },

        COOKIE_LAW(state) {
            state.cookie_status = true
        },

        SET_STELLAR_NETWORK(state, payload) {
            state.stellar_network = payload;
        },
        SET_STELLAR_NETWORK_URL(state, payload) {
            state.stellar_network_url = payload;
        },

        COLLECTION_UPLOAD_ID(state, payload) {
            state.collection_upload_id = payload;
        },
        COLLECTION_UPLOAD_SUBJECT(state, payload) {
            state.collection_upload_subject = payload;
        },
	},
	
	
	actions: {	
	}
})
